/**
 * FAA Report Models (Admin)
 *
 * Interfaces for FAA reports management in admin portal.
 */

// ============================================
// FAA REPORT STATUS
// ============================================

export type FaaReportStatus = 'draft' | 'generating' | 'ready' | 'submitted' | 'failed';

// ============================================
// FAA REPORT TYPE
// ============================================

export type FaaReportType = 'complete_faa';

// ============================================
// FAA REPORT OPTIONS
// ============================================

export interface FaaReportOptions {
  includeFlightLogs: boolean;
  includeSprayRecords: boolean;
  includePilotInfo: boolean;
  includeAircraftInfo: boolean;
}

// ============================================
// FAA REPORT
// ============================================

export interface FaaReport {
  id: string;
  organizationId: string;
  organizationName?: string;
  name: string;
  reportType: FaaReportType;
  status: FaaReportStatus;
  startDate: string;
  endDate: string;
  options: FaaReportOptions;
  generationProgress: number;
  recordCount: number | null;
  fileSize: string | null;
  reportUrl: string | null;
  downloadUrl?: string; // Pre-signed S3 URL for downloading
  submittedAt: string | null;
  submittedTo: string | null;
  errorMessage: string | null;
  createdAt: string;
  updatedAt: string;
}

// ============================================
// FAA REPORT WITH JOB INFO
// ============================================

export interface FaaReportJob {
  id: string;
  name: string;
  status: string;
  progress: number;
  attemptsMade: number;
  timestamp?: number;
  processedOn?: number;
  finishedOn?: number;
  failedReason?: string;
  finishedAt?: number;
  createdAt?: number;
}

export interface FaaReportWithJobs extends FaaReport {
  jobs: FaaReportJob[];
}

// ============================================
// QUEUE STATS
// ============================================

export interface QueueStats {
  pending: number;
  active: number;
  completed: number;
  failed: number;
}

// ============================================
// API FILTER OPTIONS
// ============================================

export interface FaaReportFilters {
  organizationId?: string;
  status?: FaaReportStatus;
  startDate?: string;
  endDate?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}
